<template>
	<div class="page">
				<v-card
					flat
					outlined
					class="wall-card"
				>
				<v-card-text>
					<v-tabs
						background-color="transparent"
						align-with-title
						class="d-flex justify-start"
					>
						<v-tab to="/groups/list">Grupy</v-tab>
						<v-tab to="/groups/user-groups">Twoje grupy</v-tab>
						<v-tab to="/groups/requested-groups">Prośby o dołączenie</v-tab>
					</v-tabs>
				</v-card-text>
				<router-view></router-view>
				<!--
				<v-tabs-items v-model="tab" class="mt-9 transparent">
					<v-tab-item>
						
							<v-card-title class="d-flex justify-content-between align-center">
								<div>
									{{ $vuetify.lang.t('$vuetify.views.groups.header') }}
								</div>
								<div>
									<v-btn
										color="accent"
										elevation="0"
										class="cursor-pointer"
										@click="showGroupCreateDialog()"
									>
										{{ $vuetify.lang.t('$vuetify.views.groups.buttons.addGroup') }}
									</v-btn>
								</div>
							</v-card-title>
							<v-card-text>
								<v-row>
									<v-col cols="8">
										<search v-model="filters.name" />
									</v-col>
									<v-col>
										<v-select
											v-model="filters.visibility"
											hide-details
											:items="selectOptions"
											outlined
											dense
											class="box-shadow-base"
											:menu-props="{ bottom: true, offsetY: true }"
											:item-text="item => item.text"
											:item-value="item => item.value"
										></v-select>
									</v-col>
								</v-row>
								<div>
									<groups-list
										v-if="groups"
										:data="groups"
										:infinite-scrolling="infiniteScrolling"
									/>
									<v-skeleton-loader
										v-if="loading"
										type="card"
										class="mt-8"
									></v-skeleton-loader>
								</div>
							</v-card-text>
						
					</v-tab-item>
					<v-tab-item>
						<user-groups />
					</v-tab-item>
					<v-tab-item>
						<requested-groups />
					</v-tab-item>
				</v-tabs-items>
				-->
				</v-card>
	</div>
</template>

<script>
//import GroupCreateDialog from "@/components/groups/GroupCreateDialog";
import {mapActions, mapGetters} from "vuex";
//import GroupsList from "@/components/groups/GroupsList";
//import RequestedGroups from "@/views/RequestedGroups";
export default {
	name: 'Groups',
	data() {
		return {
			tab: 0,
			delay: 0,
			delayer: null,
			filters: {
				search: '',
				visibility: null
			},
			loading: true,
			selectOptions: [
				{
					value: null,
					text: 'Wszystkie'
				},
				{
					value: 'public',
					text: 'Publiczne'
				},
				{
					value: 'private',
					text: 'Prywatne'
				},
			],
		}
	},
	computed: {
		...mapGetters({
			groups: "groups/groups",
			meta: "groups/meta",
		}),
	},
	watch: {
		'filters': {
			handler(v) {
				if (this.delayer) {
					clearTimeout(this.delayer)
					this.delayer = null
					this.delay = 500
				}
				this.delayer = setTimeout(async () => {
					this.loading = true
					this.clearGroups()
					v.page = 1
					await this.getGroups({ params: v })
					this.loading = false
				}, this.delay)

			},
			immediate: true,
			deep: true
		}
	},
	// created() {
	// 	this.getGroups()
	// },
	methods: {
		...mapActions('groups', [
			'getGroups',
			'clearGroups',
		]),
		showGroupCreateDialog() {
			this.$refs['group-create-dialog'].showDialog()
		},
		async infiniteScrolling(entries, observer, isIntersecting) {
			if (isIntersecting) {
				if (this.meta.current_page < this.meta.last_page && !this.loading) {
					this.loading = true
					let params = Object.assign(this.filters, {
						page: this.meta.current_page + 1
					})
					await this.getGroups({ params })
					this.loading = false
					// if (!this.loading) {
					// 	this.getPosts({ page: this.meta.current_page + 1 });
					// } else {
					// 	this.getPosts({ page: this.meta.current_page + 1 });
					// }
				}
			}
		},
	}
}
</script>

<style>
.v-tab {
	text-transform: unset;
	border-bottom: 1px solid var(--v-grey-lighten4) !important;
	letter-spacing: normal;
	font-size: 14px;
	font-weight: 600;
}
.v-slide-group__content.v-tabs-bar__content {
	gap: 8px;
}
</style>
